import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Activate() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    try {
      const { data } = await api.post("/auth/activate", { token, password });
      setSession(data); nav("/");
    } catch (e2) { setErr(apiError(e2.response?.data?.detail) || e2.message); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-6">
      <div className="w-full max-w-sm">
        <h2 className="font-display font-bold text-3xl tracking-tight">Activer votre compte</h2>
        <p className="text-muted-foreground mt-2 text-sm">Choisissez votre mot de passe pour finaliser.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="pw">Nouveau mot de passe</Label>
            <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="activate-password" />
          </div>
          {err && <p className="text-sm text-destructive" data-testid="activate-error">{err}</p>}
          <Button type="submit" className="w-full" data-testid="activate-submit">Activer mon compte</Button>
        </form>
      </div>
    </div>
  );
}
